import { LIFE_STAGE } from '~/constants/form.strings'

export const PAGE_DATA = {
  visaType: {
    visitor: [
      '600 - Visitor',
      '601 - Electronic Travel Authority',
      '461 - New Zealand Citizen Family Relationship (temporary) visa',
      '651 - eVisitor',
      '771 - Transit visa',
      '804 - Aged Parent visa',
      '870 - Sponsored Parent (Temporary) visa',
      '884 - Contributory Aged Parent (Temporary) visa',
      '866 - Protection visa'
    ],
    working: [
      '408 - Temporary Activity visa',
      '482 - Temporary Skill Shortage visa',
      '491 - Skilled Work Regional (Provisional) visa',
      '485 - Temporary Graduate visa',
      '407 - Training visa',
      '417 - Working Holiday visa',
      '462 - Work and Holiday visa',
      '188 - Business Innovation and Investment (provisional) visa',
      '190 - Skilled Nominated visa'
    ],
    student: [
      '500 - Student visa',
      '485 - Temporary Graduate visa',
      '570 - Independent ELICOS Sector visa',
      '571 - School Sector visa',
      '572 - Vocational Education and Training Sector visa',
      '573 - Higher Education Sector visa',
      '574 - Postgraduate Research Sector visa',
      '580 - Student Guardian visa'
    ],
    others: [
      '10 - Bridging visa A – BVA',
      '20 - Bridging visa B – BVB',
      '30 - Bridging visa C – BVC',
      '50 - Bridging visa E – BVE',
      '101 - Child visa',
      '102 - Adoption visa',
      '103 - Parent visa',
      '114 - Aged Dependent Relative visa',
      '115 - Remaining Relative visa',
      '116 - Carer visa',
      '117 - Orphan Relative',
      '119 - Regional Sponsor Migration Scheme',
      '120 - Labour Agreement visa',
      '121 - Employer Nomination Scheme',
      '124 - Distinguished Talent visa',
      '132 - Business Talent (Permanent) visa',
      '143 - Contributory Parent visa',
      '151 - Former Resident visa',
      '155 - Resident Return visa',
      '160 - Business Skills (Provisional) visa',
      '173 - Contributory Parent (Temporary) visa',
      '175 - Skilled Independent visa',
      '176 - Skilled Sponsored visa',
      '186 - Employer Nomination Scheme',
      '187 - Regional Sponsored Migration Scheme',
      '189 - Skilled Independent visa',
      '191 - Permanent Residence (Skilled Regional) visa',
      '200 - Refugee visas',
      '202 - Global Special Humanitarian',
      '300 - Prospective Marriage visa',
      '309 - Partner (Provisional and Migrant) visa',
      '400 - Temporary Work (Short Stay Specialist) visa',
      '401 - Temporary Work (long Stay Activity) visa',
      '402 - Training and Research visa',
      '403 - Temporary Work (International Relations) visa',
      '405 - Investor Retirement visa',
      '406 - Government Agreement visa',
      '410 - Retirement visa',
      '411 - Exchange visa',
      '415 - Foreign Government Agency',
      '416 - Special Program visa ',
      '419 - Visiting Academic visa',
      '420 - Temporary Work (Entertainment) visa',
      '421 - Sport visa',
      '422 - Medical Practitioner visa',
      '423 - Media and Film Staff visa',
      '426 - Domestic Worker (Temporary) Diplomatic and Consular visa',
      '427 - Domestic Worker (Temporary) Executive visa',
      '428 - Religious Worker visa',
      '444 - Special Category visa',
      '445 - Dependent Child visa',
      '456 - Business (Short Stay) visa',
      '457 - Temporary Work (Skilled) visa',
      '475 - Skilled Regional Sponsored visa',
      '476 - Skilled-Recognised Graduate visa',
      '487 - Skilled Regional Sponsored',
      '488 - Superyacht Crew visa',
      '489 - Skilled Regional (provisional) visa',
      '494 - Skilled Employer Sponsored Regional (provisional) visa',
      '495 - Skilled Independent Regional (Provisional) visa',
      '496 - Skilled Designated Area Sponsored visa',
      '570 - Independent ELICOS Sector visa',
      '571 - School Sector visa',
      '572 - Vocational Education and Training Sector visa',
      '573 - Higher Education Sector visa',
      '574 - Postgraduate Research Sector visa',
      '575 - Non Award Sector visa',
      '576 - Foreign Affairs or Defence sector visa',
      '580 - Student Guardian visa',
      '590 - Student Guardian visa',
      '602 - Medical Treatment visa',
      '675 - Medical Treatment (Short Stay) visa',
      '676 - Tourist visa',
      '685 - Medical Treatment Long Stay visa',
      '785 - Temporary Protection visa',
      '790 - Safe Haven Enterprise visa',
      '802 - Child visa',
      '808 - Confirmatory (Residence) visa',
      '820 - Partner visa',
      '835 - Remaining Relative visa',
      '836 - Carer visa',
      '837 - Orphan Relative',
      '838 - Aged Dependent Relative visa',
      '845 - Established Business in Australia visa',
      '846 - State or Territory Sponsored Regional Established Business in Australia visa',
      '855 - Labour Agreement visa',
      '858 - Global Talent visa',
      '864 - Contributory Aged Parent visa',
      '885 - Skilled Independent visa',
      '886 - Sponsored visa',
      '887 - Skilled Regional visa',
      '888 - Business Innovation and Investment (permanent) visa',
      '890 - Business Owner',
      '891 - Investor visa',
      '892 - State or Territory Sponsored Business Owner visa',
      '893 - State or Territory Sponsored Investor visa',
      '942 - Crew Travel Authority visa',
      '956 - Electronic Travel Authority (Business Entrant) visa',
      '976 - Electronic Travel Authority (Visitor) visa',
      '988 - Maritime Crew visa'
    ]
  }
}

export const FORM_STEPS = [
  'Step 2',
  'Step 3',
  'Step 4',
  'Step 5',
  'Step 6',
  'Step 7'
]

export const ERROR_MAP = {
  life_stage: 'Please select what you\'re looking for',
  visa_type: 'Please select your visa type',
  visa_subtype: 'Please select your visa subclass',
  check_visa_compatibility: 'Please select if you have 8501 visa condition',
  visa_code: 'Please input your visa code',
  already_in_australia: 'Please select one option',
  country_of_citizenship: 'Please select your main country of citizenship',
  cover_level: 'Please select your cover level',
  state_in_australia: 'Please select your state',
  date_of_birth: 'Please enter your date of birth',
  partner_birthdate: 'Please enter your partner’s date of birth',
  expected_entry_date: 'Please enter your expected date of entry',
  include_pregnancy_related_cover: 'Please select an option'
}

export const FORM_HEADER = {
  step1: {
    title: '<strong class="font-extrabold">Customise</strong> Your Cover for your needs',
    desc: 'To help you with quotes that best suit your needs, first we need to know a little bit about you and your circumstances.',
    component: 'div',
    img: '/icons/ovhc/customized_cover.svg'
  },
  step2: {
    title: '<strong class="font-extrabold">Customise</strong> Your Cover for your needs',
    desc: 'To help you with quotes that best suit your needs, first we need to know a little bit about you and your circumstances.',
    component: 'div',
    img: '/icons/ovhc/customized_cover.svg'
  },
  step3: {
    title: '<strong class="font-extrabold">Customise</strong> Your Cover for your needs',
    desc: 'To help you with quotes that best suit your needs, first we need to know a little bit about you and your circumstances.',
    component: 'div',
    img: '/icons/ovhc/customized_cover.svg'
  },
  step4: {
    title: 'Which <strong>Australian state</strong> do you live in?',
    desc: 'Different states have different health insurance premiums. So simply choose the state you live in.',
    component: 'div',
    img: '/icons/ovhc/au_state.svg'
  },
  step5: {
    title: 'What is your <strong>date of birth?</strong>',
    desc: 'Your birth date determines if you\'re eligible for an age-based discount and a reduced health insurance premium.',
    component: 'div',
    img: '/icons/ovhc/life_stage.svg'
  }
}

export const FORM_QUESTIONS = {
  lifeStage: {
    question: 'I am looking for',

    components: [
      {
        component: 'MoleculesSelectDropdown',
        props: {
          name: 'life_stage',
          label: 'Cover type',
          placeholder: 'Select cover type',
          dataValue: 'value',
          dataInputDisplay: 'label',
          dataListDisplay: 'label',
          dataArr: LIFE_STAGE
        }
      }
    ]
  },
  visaType: {
    question: 'Visa Type',
    components: [
      {
        component: 'MoleculesSelectDropdown',
        props: {
          name: 'visa_type',
          label: 'Visa type',
          placeholder: 'Select visa type',
          dataValue: 'value',
          dataArr: [
            {
              name: 'Visitor',
              value: 'Visitor'
            },
            {
              name: 'Working',
              value: 'Working'
            },
            {
              name: 'Students',
              value: 'Student'
            }
          ]
        }
      }
    ]
  },
  visaSubtype: {
    question: 'Visa Subclass',
    components: [
      {
        component: 'MoleculesSelectDropdown',
        props: {
          label: 'Visa subclass',
          placeholder: 'Select visa subclass',
          dataInputDisplay: 'value',
          dataValue: 'value',
          dataArr: []
        }
      }
    ]
  },
  visaCode: {
    question: 'Enter visa subclass',
    components: [
      {
        component: 'AtomsInput',
        props: {
          placeholder: 'Input 3-4 digits Visa code',
          modelType: 'number',
          label: '',
          maxlength: '4'
        }
      }
    ]
  },
  checkVisaCompatibility: {
    question: '8501 Visa Condition ?',
    components: [
      {
        component: 'MoleculesSelectDropdown',
        props: {
          name: 'check_visa_compatibility',
          label: '8501 Visa Condition ?',
          placeholder: 'Select visa condition',
          dataValue: 'value',
          tooltip : {
            redirectTo: 'visaCondition8501'
          },
          dataArr: [
            {
              name: 'Yes',
              value: 'yes'
            },
            {
              name: 'No',
              value: 'no'
            }
          ]
        }
      } 
    ]
  },
  countryOfCitizenship: {
    question: 'What\'s your main country of citizenship?',
    components: [
      {
        component: 'MoleculesCountry',
        props: {
          name: 'citizenship',
          label: 'Country of citizenship',
          theme: 'light',
          dropdownModelType: 'dropdown',
          placeholder: ''
        }
      }
    ]
  },
  alreadyInAustralia: {
    question: 'Are you currently in Australia?',
    components: [
      {
        component: 'MoleculesSelection',
        props: {
          name: 'citizenship',
          type: 'radio',
          ticker: 'none',
          options: [
            {
              name: 'Yes',
              label: '<p class="text-center text-lg font-bold">Yes</p>',
              value: 'Yes'
            },
            {
              name: 'No',
              label: '<p class="text-center text-lg font-bold">No</p>',
              value: 'No'
            },
            {
              name: 'Applying for somebody else',
              label: '<p class="text-center text-lg font-bold">Applying for somebody else</p><p class="text-sm text-center">(eg. overseas relatives)</p>',
              value: 'Applying for somebody else'
            }
          ]
        }
      }
    ]
  },
  stateInAustralia: {
    question: 'Select your state',
    components: [
      {
        component: 'MoleculesStates',
        props: {
          type: 'radio'
        }
      }
    ]
  },
  expectedEntryDate: {
    question: 'What is your expected date of entry into Australia?',
    components: [
      {
        component: 'AtomsDatepicker',
        props: {
          label: 'Enter your arrival date (dd/mm/yyyy)',
          placeholder: 'Enter your arrival date (dd/mm/yyyy)',
          modelType: 'date',
          disableDatepicker: true,
          theme: 'light'
        }
      }
    ]
  },
  dateOfBirth: {
    question: 'Enter your date of birth',
    components: [
      {
        component: 'MoleculesBirthdate',
        props: {
          label: 'Enter your date of birth (dd/mm/yyyy)',
          placeholder: 'Enter your date of birth (dd/mm/yyyy)',
          validAge: PAGE_DATA.validAge,
          disableDatepicker: true,
          theme: 'light'
        }
      }
    ]
  },
  partnerBirthdate: {
    question: 'Enter your partner’s date of birth',
    components: [
      {
        component: 'MoleculesBirthdate',
        props: {
          label: 'Enter your partner’s date of birth (dd/mm/yyyy)',
          placeholder: 'Enter your partner’s date of birth (dd/mm/yyyy)',
          validAge: PAGE_DATA.validAge,
          disableDatepicker: true,
          theme: 'light'
        }
      }
    ]
  },
  coverLevel: {
    question: 'What level of cover would you like?',
    components: [
      {
        component: 'MoleculesSelection',
        props: {
          name: 'cover_level',
          type: 'radio',
          ticker: 'none',
          options: [
            {
              name: 'basic',
              label: '<p class="font-bold">Basic</p><p class="text-xs font-normal">Cheap basic cover to meet my visa requirements.</p>',
              value: 'basic'
            },
            {
              name: 'medium',
              label: '<p class="font-bold">Medium</p><p class="text-xs font-normal">Moderate level of cover that provides some additional benefits.</p>',
              value: 'medium'
            },
            {
              name: 'top',
              label: '<p class="font-bold">Top</p><p class="text-xs font-normal">I want the highest possible level of cover.</p>',
              value: 'top'
            }
          ]
        }
      }
    ]
  }
}

export const FORM_ITEMS_ARR = {
  step1: [
    'lifeStage',
    'visaType',
    'visaSubtype',
    'visaCode',
    'checkVisaCompatibility'
  ],
  step2: [
    'alreadyInAustralia'
  ],
  step3: [
    'countryOfCitizenship'
  ],
  step4: [
    'stateInAustralia',
    'expectedEntryDate'
  ],
  step5: [
    'dateOfBirth',
    'partnerBirthdate'
  ]
}
